import {observer} from 'mobx-react-lite'
import React, {forwardRef, useState} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {DataObjectId, DealActivityType, Hub} from 'yougile-model'
import {ButtonNew} from '@components/common/base/buttons'
import {InputNew} from '@components/common/base/input-new'
import {
  getDealActivityDeadlineColor
} from '@components/crm-activities-view/get-deal-activity-color'
import {globals} from '../../../../../extensions/globals-base'
import {UserStickerState} from '../../../../../extensions/sticker/views-web/user/user-sticker-state'
import {getUserIdsInProjectByTask} from '../../../../crm-activities-view/activities-data/get-user-ids-in-project-by-board'
import {DealHistorySwitcher} from './deal-history-switcher'
import {DealTimeDatePicker} from './deal-time-date-picker'
import {useSendMessageAction} from './use-send-message-action'

interface Props {
  hub: Hub
  typeActivity: DealActivityType
  setTypeActivity: (typeActivity: DealActivityType) => void
}

const TwContainer = tw.div`
  flex
  p-20
  bg-primary
`

const TwContent = tw.div`
  w-full
  p-12
  flex
  gap-12
  flex-col
  rounded-12
  border-solid
  border-border-base
  border-1
`

export const DealTimeInputPanel = observer(
  forwardRef((props: Props, inputRef: React.RefObject<HTMLInputElement>) => {
    const {hub, typeActivity, setTypeActivity} = props
    const {sendMessage, input, setInput} = useSendMessageAction({
      hub,
      typeActivity
    })

    const [deadline, setDeadline] = useState<number>(getNextDay())
    const [assigned, setAssigned] = useState<DataObjectId[]>([
      globals.currentUserId
    ])

    const userIds = getUserIdsInProjectByTask(hub)

    return (
      <TwContainer>
        <TwContent>
          <div className="flex justify-between items-center flex-wrap row-gap-4">
            <DealHistorySwitcher
              onChange={type => {
                setTypeActivity(type)
                inputRef.current?.focus()
              }}
            />

            {typeActivity === 'deal' && (
              <div className="flex items-center text-sm-regular gap-12">
                <DealTimeDatePicker
                  color={getDealActivityDeadlineColor(deadline)}
                  date={deadline}
                  setDate={setDeadline}
                  icon={true}
                />

                <UserStickerState
                  placement="top"
                  avatarsClassName="flex items-center"
                  users={assigned}
                  options={userIds}
                  onChoose={setAssigned}
                  singleMode
                  maxShow={3}
                  title={Lang.msg.assigned}
                  size={16}
                />
              </div>
            )}
          </div>

          <div className="flex gap-8">
            <InputNew
              ref={inputRef}
              className="flex-1"
              value={input}
              onChange={setInput}
              onKeyDown={event =>
                event.key === 'Enter' && sendMessage({deadline, assigned})
              }
              placeholder={
                typeActivity === 'deal'
                  ? Lang.msg.crm.rightPanel.dealHistory.placeholderDeal
                  : Lang.msg.crm.rightPanel.dealHistory.placeholderNote
              }
              size="md"
              isAutoWidth={false}
            />
            <ButtonNew
              title={Lang.msg.crm.rightPanel.dealHistory.create}
              onClick={() => sendMessage({deadline, assigned})}
            />
          </div>
        </TwContent>
      </TwContainer>
    )
  })
)

const getNextDay = (): number => {
  const nextMidnight = new Date()
  nextMidnight.setHours(36, 0, 0, 0)
  return nextMidnight.getTime()
}
